
<div class='back-to-dashboard' (click)="backToDashboard()">
    <mat-icon>arrow_back_ios</mat-icon>
    <span style='vertical-align:top;'>{{ 'service.back' | translate}}</span>
</div>
<app-loading size="0.5" class="loading-spinner" *ngIf="load else wrapper" color="var(--primary-sec-color)"></app-loading>
<ng-template #wrapper>
<div class="heading">
    {{ 'testDrive.scheduleTestDrive' | translate}}
    <ng-container *ngIf="!isUpdate && (customerDetails$ | async)?.firstName">
        {{ 'delivery.for' | translate}} {{(customerDetails$ | async)?.firstName |titlecase }} {{(customerDetails$ | async)?.lastName |titlecase }}
    </ng-container>
    <ng-container *ngIf="isUpdate && customerDataOnEdit?.firstName">
        {{ 'delivery.for' | translate}} {{customerDataOnEdit?.firstName |titlecase }} {{customerDataOnEdit?.lastName |titlecase }}
    </ng-container>
</div>

<div class='container testdrive-content' [formGroup]='testDriveForm'>
    <div class="search-customer-wrapper container">
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Vehicle information
                </mat-panel-title>
                <mat-panel-description class="form-status">
                    <span class="in-complete" *ngIf="!validVehicleForm || ((searchVinForm.controls.vin.valid) && (vehicleDetails.isInvalid && vehicleDetails.source === 'CRM') || (vehicleDetails.isInvalid && vehicleDetails.source !== 'CRM') || (vehicleDetails.notAvailable))">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                    <span class="complete" *ngIf="validVehicleForm && (!(vehicleDetails.isInvalid && vehicleDetails.source === 'CRM') && !(vehicleDetails.isInvalid && vehicleDetails.source !== 'CRM') && !(vehicleDetails.notAvailable))">{{ 'deliveryChecklist.formComplete' | translate }} </span>
                </mat-panel-description>
            </mat-expansion-panel-header>
            <div  class="search-customer-wrapper container">
                <app-vehicle-delivery [vehicleDetails]='vehicleDetailsEdit' [showSplitter]="isUpdate"></app-vehicle-delivery> 
            </div>
    <div class="search-customer-wrapper container">
        <span *ngIf="!isUpdate" class="select-vehicle-header">{{ 'delivery.selectVehicle' | translate}}</span>
        <span *ngIf="isUpdate" class="select-vehicle-header">{{ 'delivery.changeVehicle' | translate}}</span>
        <form class="search-form" [formGroup]="searchVinForm" (ngSubmit)="submitVinForm()">
            <div  class="field-container">
                <div class="field">
                    <label class="stock-label">{{ 'service.enterTheVin' | translate}}<span style="color: red">*</span></label>
                    <mat-form-field class="search-input mat-input" appearance="outline">
                        <input type="text" matInput [placeholder]="'service.enterThe17DigitVin' | translate" (input)="onSearchChange()" formControlName="vin" autocomplete="off" maxlength="300" required>
                        <mat-error
                          *ngIf=" searchVinForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric"
                        >{{searchVinForm.controls.vin.errors?.pattern17DigitAndAlphaNumeric | translate}}</mat-error>
                        <mat-error
                          *ngIf=" searchVinForm.controls.vin.errors?.pattern17Digit"
                        >{{searchVinForm.controls.vin.errors?.pattern17Digit | translate}}</mat-error>
                        <mat-error
                          *ngIf=" searchVinForm.controls.vin.errors?.patternAlphaNumeric"
                        >{{searchVinForm.controls.vin.errors?.patternAlphaNumeric | translate}}</mat-error>
                    </mat-form-field>
                    <div class="vin-error" *ngIf="vehicleDetails.isInvalid && vehicleDetails.source === 'CRM'">{{ 'delivery.notFoundInInventory' | translate}}</div>
                    <div class="vin-error" *ngIf="vehicleDetails.isInvalid && vehicleDetails.source !== 'CRM'">{{ 'delivery.vehicleNotFound' | translate}}</div>
                    <div class="vin-error" *ngIf="vehicleDetails.notAvailable">{{ 'delivery.notAvailableForTestDrive' | translate}} </div>
                </div>
                <div class="field buttons">
                    <button type="submit" class="save-btn">
                        <span>{{ 'searchCustomer.search' | translate}}</span>
                    </button>
                </div>
            </div>
        </form>
    </div>
    <div  *ngIf="searchWithVin && isVinValid" class="search-customer-wrapper container">
        <app-vehicle-delivery [vehicleDetails]='vehicleDetails' [showSplitter]="isUpdate"></app-vehicle-delivery> 
    </div>
    <div>
        <div id="or-ele" class="anime-element">{{ 'testDrive.or' | translate}}</div>
        <app-vehicle-configurator
        [searchWithVin]="searchWithVin"
        [isEditMode]="isUpdate || !!vinTestDrive"
        [vin]="vinTestDrive"
        [withoutFleetVehicle]="withoutFleetVehicle"
        (formEdited)="formValuesChanges($event)"
        (sourceChanged)="sourceChanged($event)">
        </app-vehicle-configurator>
    </div>
    </mat-expansion-panel >
    </div>
    
    <div  class="search-customer-wrapper container">
    <mat-accordion multi>

        <div>
            <mat-expansion-panel [expanded]="!showMandatoryMsgCI && isUpdate">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        {{ 'otherTexts.customerInformation' | translate}}
                    </mat-panel-title>
                    <mat-panel-description class="form-status">
                        <span class="in-complete" *ngIf="!showMandatoryMsgCI">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                        <span class="complete" *ngIf="showMandatoryMsgCI">{{ 'deliveryChecklist.formComplete' | translate }} </span>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <app-contact-email-info formControlName="customer" (formEdited)="formValuesChanges($event)" (isCIformValid)="isCIformValid($event)" [apptType]="apptType"></app-contact-email-info>
            </mat-expansion-panel>
        </div>

        <mat-expansion-panel [expanded]="isCustomerPanelExpanded">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ 'otherTexts.appointmentLocation' | translate}}
                </mat-panel-title>
                <mat-panel-description class="form-status" *ngIf="testDriveForm.value.transportationTypeCode === 'REMOTE'">
                    <span class="in-complete" *ngIf="!testDriveForm.controls.address.valid">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                    <span class="complete" *ngIf="testDriveForm.controls.address.valid">{{ 'deliveryChecklist.formComplete' | translate }} </span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <app-toggle-location *ngIf="hasRemoteLocation" [allTransportOptions]="transportOptions$ | async"
                [formControlName]="'transportationTypeCode'" [department]="aptType" (click)="checkZipCodes(testDriveForm.value.remoteZipCode)">
            </app-toggle-location>

            <ng-container *ngIf="testDriveForm.value.transportationTypeCode === 'REMOTE'">
                    <div style="text-align: center; font-size: 0.8rem;">{{ 'testDrive.pleaseEnterCustomerZipcodeToCheckTheDealer' | translate}}</div>
                    <div class="zip">
                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'common.Zipcode' | translate}}</mat-label>
                            <input matInput required #zip [placeholder]="'common.Zipcode' | translate" formControlName="remoteZipCode"
                                (input)="checkZipCodes(zip.value)" />
                            <mat-error>{{ 'service.sorryRemoteServicesAreNotAvailableTxt' | translate}}</mat-error>
                        </mat-form-field>
                        <div class="tick" [ngClass]="{'selected' : isValidRemoteZip}"></div>
                    </div>
            </ng-container>

            <app-customer-info formControlName="address" [location]="testDriveForm.value.transportationTypeCode"
                [department]="'sales'" [remoteValidZipcodes]="remoteValidZipcodes"
                (formEdited)="formValuesChanges($event)">
            </app-customer-info>

        </mat-expansion-panel>
        
        <div *ngIf="false" class='other-vehicles'>
            <mat-expansion-panel #otherVehicle [disabled]='!otherVehicleCheckbox.checked'
                [expanded]='otherVehicleCheckbox.checked'>
                <mat-expansion-panel-header [ngClass] = "{'show-cursor' : !otherVehicleChecked}">
                    <mat-panel-title>
                        <mat-checkbox #otherVehicleCheckbox disableRipple (change)="onOtherVehicleChecked()"
                            [checked]="otherVehicleChecked">
                        </mat-checkbox>
                        <span class='checkbox-text'>{{ 'testDrive.isTheCustomerInterestedInOtherVehicles' | translate}}</span>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div formArrayName='otherVehicles'>
                    <div class='dropdown' *ngFor="let other of otherVehiclesArray?.controls, let i = index"
                        [formGroupName]="i">
                        <app-splitter class='app-splitter' [config]="'horizontal 100% 0 -.4rem 550px'"></app-splitter>

                        <mat-form-field appearance="outline">
                            <mat-label>{{ 'testDrive.year' | translate}}</mat-label>
                            <mat-select formControlName='year' [required]="otherVehicleChecked">
                                <mat-option *ngFor="let year of yearList$ | async" [value]="year">{{year}}</mat-option>
                            </mat-select>
                            <mat-error>{{'testDrive.pleaseSelectAValidYear' | translate}}</mat-error>
                            <mat-hint *ngIf="!!other.value.year && !(modelList$[i] | async)?.length">{{'testDrive.noModelsForTheYear' | translate}}</mat-hint>
                        </mat-form-field>

                        <mat-form-field appearance="outline"
                        [ngClass]="{'disabled' : !(modelList$[i] | async)?.length}">
                            <mat-label>{{ 'testDrive.model' | translate}}</mat-label>
                            <mat-select formControlName='model' [required]="otherVehicleChecked">
                                <mat-option *ngFor="let model of modelList$[i] | async" [value]="model.modelCode">
                                    {{model.modelTitle}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{'testDrive.pleaseSelectAValidModel' | translate}}</mat-error>
                        </mat-form-field>

                        <mat-form-field appearance="outline"
                        [ngClass]="{'disabled' : !(trimList$[i] | async)?.length}">
                            <mat-label>{{ 'testDrive.trim' | translate}}</mat-label>
                            <mat-select formControlName='trim' [required]="otherVehicleChecked">
                                <mat-option *ngFor="let trim of trimList$[i] | async" [value]="trim.trimCode">
                                    {{trim.trimTitle}}
                                </mat-option>
                            </mat-select>
                            <mat-error>{{'testDrive.pleaseSelectAValidTrim' | translate}}</mat-error>
                        </mat-form-field>
                        <asp-icon class='app-icon' height='1rem' width='1rem' name='ic-20-utility-delete-trash.svg'
                        color="rgba(14,19,25,0.8)" (click)='onDeleteVehicle(i)'>
                        </asp-icon>
                    </div>
                </div>

                <div class='add-vehicle' [ngClass]="{'disabled': otherVehiclesArray?.controls.length >= 3}">
                    <asp-icon class='app-icon' name='element-btn-48-icon-primary.svg' (click)='onAddVehicle()'>
                    </asp-icon>
                    <span class='desc' (click)='onAddVehicle()'>{{ 'testDrive.addAnotherVehicle' | translate}}</span>
                </div>
            </mat-expansion-panel>
        </div>

        <app-trade-in-info formControlName="tradeIn"  (formEdited)="formValuesChanges($event)" [isTradeInEnabled]="settings?.portal?.enableTradeIn"></app-trade-in-info>

        <mat-expansion-panel  [expanded]="!testDriveForm.controls.availability.valid && isUpdate">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    {{ 'service.appointmentAvailability' | translate}}
                </mat-panel-title>
                <mat-panel-description class="form-status">
                    <span class="in-complete" *ngIf="!testDriveForm.controls.availability.valid">{{ 'deliveryChecklist.formIncomplete' | translate }} </span>
                    <span class="complete" *ngIf="testDriveForm.controls.availability.valid">{{ 'deliveryChecklist.formComplete' | translate }} </span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            
            <app-availability *ngIf="isUpdate && languageId!=='';else noEdit" class='app-availability' formControlName='availability'
                [options]="availabilityOptions$ | async" [isAvailabilityLoading]="availabilityLoading$ | async"
                [availability]="availability$ | async" [apptType]="apptType" [selectedTransport]="testDriveForm.value.transportationTypeCode" (monthChanged)="onMonthChange($event)"
                (formEdited)="formValuesChanges($event)" [showClearDateTimeBtn]="true" [isEditMode]="isUpdate" [customerLanguage]="languageId" [vin]="testDriveVins" [appointmentId]="appointmentId">
            </app-availability>
            <ng-template #noEdit>
                <app-availability class='app-availability' formControlName='availability'
                    [options]="availabilityOptions$ | async" [isAvailabilityLoading]="availabilityLoading$ | async"
                    [availability]="availability$ | async" [apptType]="apptType" [selectedTransport]="testDriveForm.value.transportationTypeCode" (monthChanged)="onMonthChange($event)"
                    (formEdited)="formValuesChanges($event)" [showClearDateTimeBtn]="true" [vin]="testDriveVins">
                </app-availability>
            </ng-template>

        </mat-expansion-panel>
    </mat-accordion>
</div>
</div>
<div class="testdrive-content" id="testdrive-sticky-footer">
    <div id="accept-terms">
        <span class="label">
        {{getDisclaimerText}}
        </span>
    </div>
    <div class='appointment-submit'>
        <button class='submit' [class.submitting]="isSubmitting" (click)='onSubmit()'
            [ngClass]="isValidForm() ? 'enabled':''" [disabled]="isSubmitting">
            <ng-container *ngIf="isSubmitting; else testDriveSubmitLabel">
                <app-loading loadingSymbol="dots" [text]="'testDrive.submitting' | translate" color="white" size=".7" [compact]="true"></app-loading>
            </ng-container>
            <ng-template #testDriveSubmitLabel>
                {{'testDrive.submit' | translate}}
            </ng-template>
        </button>
    </div>
    <div class='appointment-details' *ngIf="isValidForm()">
        {{'testDrive.theAppointmentIsOn' | translate}}{{getTranslation(testDriveForm.get('availability').value.appointmentStartDate | date : 'MMMM')}} {{ testDriveForm.get('availability').value.appointmentStartDate | date : ' dd' }} 
        {{'testDrive.aT' | translate}} {{ testDriveForm.get('availability').value.timeSlotId }} at
        {{ testDriveForm.get('transportationTypeCode').value == 'REMOTE' ? ('testDrive.atRemoteLocation' | translate) : ('testDrive.atDealershipLocation' | translate) }}
    </div>
</div>
</ng-template>